exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-square-sm{height:200px;font-size:xx-large;border-radius:10px}.btn-rectangle-sm-a{height:134px;font-size:x-large;border-radius:10px}.btn-rectangle-sm-b{height:58px;font-size:x-large;border-radius:10px}.btn-square-xs{height:120px;font-size:xx-large;border-radius:10px}.btn-rectangle-xs-a{height:76px;font-size:x-large;border-radius:10px}.btn-rectangle-xs-b{height:38px;font-size:larger;border-radius:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-67171dc8","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Stopwatch.vue
// module id = 326
// module chunks = 0